import { render, staticRenderFns } from "./KiKostenZeile.vue?vue&type=template&id=27183614&scoped=true"
import script from "./KiKostenZeile.vue?vue&type=script&lang=js"
export * from "./KiKostenZeile.vue?vue&type=script&lang=js"
import style0 from "./KiKostenZeile.vue?vue&type=style&index=0&id=27183614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27183614",
  null
  
)

export default component.exports